<div class="wrapper">
  <app-sidebar />
  <div class="color-line"></div>

  <app-topbar
    [title]="title"
    [subTitle]="subTitle"
    (settingsButtonClicked)="onSettingsButtonClicked()"
    (mobileMenuButtonClicked)="onToggleMobileMenu()"
  />
  <div class="page-content">
    <div class="page-container">
      <router-outlet (activate)="onActivate($event)" />
    </div>
    <footer class="footer">
      <div class="page-container">
        <div class="row">
          <div class="col-md-6 text-center text-md-start">
            {{ year }} © RedFin - By
            <span
              class="fw-bold text-decoration-underline text-uppercase text-reset fs-12"
              >Venetronic</span
            >
          </div>
          <!-- <div class="col-md-6">
            <div class="text-md-end footer-links d-none d-md-block">
              <a href="javascript: void(0);">About</a>
              <a href="javascript: void(0);">Support</a>
              <a href="javascript: void(0);">Contact Us</a>
            </div>
          </div> -->
        </div>
      </div>
    </footer>
  </div>
</div>
